export default "__VITE_ASSET__onJPMaid__"